/**
 * TransactionRefundService
 * Service for TransactionRefund entity operations
 * Route: api/transaction-refund
 * Controller: TransactionRefundController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * TransactionRefundService
 * Handles transaction refund CRUD operations and model view queries
 * Maps to /api/transaction-refund endpoint
 */
export class TransactionRefundService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? TransactionRefundService.DEFAULT_SERVICE_PATH,
            basePath: TransactionRefundService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // Override getById to support GUID
    async getById(id) {
        const response = await this.getByIdRaw(id);
        if (!response.data) {
            throw new Error(`Transaction refund with ID ${id} not found`);
        }
        return response.data;
    }
    getByIdRaw(id) {
        const url = this.buildUrl(id);
        return this.http.get(url);
    }
    // ==================== CACHE INVALIDATION ====================
    /**
     * Invalidate transaction refund cache
     * POST /api/transaction-refund/cache/invalidate
     */
    async invalidateCache() {
        const response = await this.invalidateCacheRaw();
        return response.data ?? false;
    }
    /**
     * Invalidate transaction refund cache (raw)
     */
    invalidateCacheRaw() {
        const endpoint = this.getEndpoint('cache-invalidate', 'cache/invalidate');
        const url = this.buildUrl(endpoint);
        return this.http.post(url, {});
    }
    // ==================== MODEL VIEW ENDPOINTS ====================
    /**
     * Get refund model view by ID
     * GET /api/transaction-refund/view/{id}
     */
    async getView(id) {
        const response = await this.getViewRaw(id);
        if (!response.data) {
            throw new Error(`Refund view with ID ${id} not found`);
        }
        return response.data;
    }
    /**
     * Get refund model view by ID (raw)
     */
    getViewRaw(id) {
        const url = this.buildUrl(`view/${id}`);
        return this.http.get(url);
    }
    /**
     * Get all refund model views
     * GET /api/transaction-refund/view
     */
    async getAllViews() {
        const response = await this.getAllViewsRaw();
        return response.data ?? [];
    }
    /**
     * Get all refund model views (raw)
     */
    getAllViewsRaw() {
        const url = this.buildUrl('view');
        return this.http.get(url);
    }
    /**
     * Get refund views by transaction ID
     * GET /api/transaction-refund/transaction/{transactionId}/view
     */
    async getViewsByTransaction(transactionId) {
        const response = await this.getViewsByTransactionRaw(transactionId);
        return response.data ?? [];
    }
    /**
     * Get refund views by transaction ID (raw)
     */
    getViewsByTransactionRaw(transactionId) {
        const url = this.buildUrl(`transaction/${transactionId}/view`);
        return this.http.get(url);
    }
}
TransactionRefundService.DEFAULT_SERVICE_PATH = 'payments';
TransactionRefundService.BASE_PATH = 'api/transaction-refund';
//# sourceMappingURL=TransactionRefundService.js.map